import { render, staticRenderFns } from "./chufang.vue?vue&type=template&id=6ce9982c&scoped=true&"
import script from "./chufang.vue?vue&type=script&lang=ts&"
export * from "./chufang.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce9982c",
  null
  
)

export default component.exports